/**
 * Function to check if the user prefers reduced motion.
 * Listens for changes in the preference and dispatches a custom event.
 *
 * @returns {boolean} Returns true if the user prefers reduced motion, otherwise false.
 */
const prefersReducedMotion = () => {
  const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  
  // Function to handle changes in the user's reduced motion preference.
  // Dispatches a custom event with the current preference.
  const handleReducedMotionChange = () => {
	const event = new CustomEvent('reducedMotionChange', { detail: mediaQuery.matches });
	document.dispatchEvent(event);
  };
  
  // Listen for changes in the user's preference for reduced motion
  mediaQuery.addEventListener('change', handleReducedMotionChange);
  
  // Return the current state
  return mediaQuery.matches;
};

export default prefersReducedMotion;